import Model from './Model'

export default class Key extends Model
{
    static async all (query = null) {
        const config = { params: { query } }
        const { data } = await Http.get(route('api.v1.keys.index'), config)
        return this.make(data)
    }

    static async create (attributes) {
        const url = route('api.v1.keys.store')
        const { data } = await Http.post(url, this.parseAttributes(attributes))
        return this.make(data)
    }

    static async find (id) {
        const { data } = await Http.get(route('api.v1.keys.show', id))
        return this.make(data)
    }

    async update (attributes = {}) {
        const url = route('api.v1.keys.update', this.id)
        const payload = this.constructor.parseAttributes({ ...this.getFormAttributes(), ...attributes })
        const { data } = await Http.put(url, payload)
        return this.fill(data)
    }

    async delete () {
        await Http.delete(route('api.v1.keys.destroy', this.id))
    }

    async addUsage (attributes) {
        const url = route('api.v1.keys.usages.store', this.id)
        
        if (attributes.contact?.value) {
            attributes.contact_type = attributes.contact.value.split('_')[0]
            attributes.contact_id = attributes.contact.value.split('_')[1]
        }

        await Http.post(url, attributes)
    }
}
